module.exports = __webpack_public_path__ + "static/media/avisoprivacidad.520ad377.png";